export default __webpack_public_path__ + "static/media/OpeningVideoCreate_1mbs.d59670bf.mp4";